export default __webpack_public_path__ + "static/popup-image-6a36ed6f7ca982a0794acf23f44e074c.jpg";